export default __webpack_public_path__ + "static/media/5.04cade70.jpg";